import { render, staticRenderFns } from "./InformationModal.vue?vue&type=template&id=2418bdb0"
import script from "./InformationModal.vue?vue&type=script&lang=js"
export * from "./InformationModal.vue?vue&type=script&lang=js"
import style0 from "./InformationModal.vue?vue&type=style&index=0&id=2418bdb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports